export const mgPlatformCalendarPlusIcon = {
  data: `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.25 7.25V4.75C15.25 3.64543 14.3546 2.75 13.25 2.75H2.75C1.64543 2.75 0.75 3.64543 0.75 4.75V13.25C0.75 14.3546 1.64543 15.25 2.75 15.25H7.25M13 10.75V15.25M15.25 13H10.75M4 0.75V4.25M12 0.75V4.25M3.75 6.75H12.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  name: 'calendar-plus'
}
